import styled from 'styled-components'

export const PageWrapper = styled.div`
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding: 0 15px;
  max-width: 670px;
`

export const FormButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 28px;
  margin-bottom: 30px;
  gap: 10px;
`

export const DraggerUploadStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .anticon {
    font-size: 24px;
  }
`

export const InfoBlock = styled.dl`
  display: flex;
  flex-wrap: wrap;
  margin: 24px 0;
  background: #ffffff;
  border: 1px solid #eaecef;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);

  dt,
  dd {
    margin-bottom: 0;
    padding: 14px 20px;
    font-size: 14px;
    line-height: 1.6;
    box-sizing: border-box;
  }

  dt {
    width: 200px;
    color: #667085;
    font-weight: 600;
    background-color: #f8f9fb;
    border-bottom: 1px solid #eaecef;
    display: flex;
    align-items: center;
  }

  dd {
    width: calc(100% - 200px);
    color: #1d2433;
    border-bottom: 1px solid #eaecef;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  dt:first-of-type,
  dd:first-of-type {
    background-color: #eef4ff;
    border-bottom: 1px solid #dbe6fb;
  }

  dt:first-of-type {
    color: #1d4ed8;
    font-weight: 700;
    letter-spacing: 0.2px;
  }

  dd:first-of-type {
    color: #1d4ed8;
    font-weight: 500;
  }

  dt:last-of-type,
  dd:last-of-type {
    border-bottom: none;
  }

  dd:last-child {
    white-space: pre-wrap;
  }

  @media (max-width: 576px) {
    dt,
    dd {
      width: 100% !important;
    }

    dt {
      border-bottom: none;
      padding-bottom: 4px;
    }

    dd {
      padding-top: 0;
    }
  }
`

export const ParticipationSideBlock = styled.div`
  position: sticky;
  top: 20px;
  margin-top: 24px;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #eaecef;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);

  .participation-title {
    font-size: 15px;
    font-weight: 700;
    color: #1d2433;
    margin-bottom: 16px;
    padding-bottom: 14px;
    border-bottom: 1px solid #eaecef;
  }

  .participation-section {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .participation-label {
    color: #667085;
    margin-bottom: 10px;
    font-size: 12.5px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.4px;
  }

  .ant-radio-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .ant-radio-wrapper {
    display: flex;
    align-items: center;
    margin-right: 0;
    margin-bottom: 0;
    padding: 8px 10px;
    border-radius: 8px;
    border: 1px solid #eaecef;
    transition: border-color 0.15s ease, background-color 0.15s ease;

    &:hover {
      border-color: #93b4f8;
      background-color: #f8faff;
    }

    &.ant-radio-wrapper-checked {
      border-color: #1d4ed8;
      background-color: #eef4ff;
    }
  }

  .participation-stats {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .participation-stat-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    color: #344054;
    padding: 6px 10px;
    background: #f8f9fb;
    border-radius: 8px;
  }

  .participation-stat-count {
    font-weight: 700;
    color: #1d2433;
    background: #ffffff;
    border: 1px solid #eaecef;
    border-radius: 999px;
    min-width: 26px;
    height: 22px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 6px;
    font-size: 12px;
  }

  .participation-stat-row.clickable {
    cursor: pointer;

    &:hover {
      background: #eef4ff;
    }

    &:hover .participation-stat-count {
      border-color: #1d4ed8;
      color: #1d4ed8;
    }
  }
`

export const ParticipationModalWrap = styled.div`
  .ant-modal-content {
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 12px 36px rgba(16, 24, 40, 0.16);
  }

  .ant-modal-header {
    padding: 18px 24px;
    border-bottom: 1px solid #eaecef;
  }

  .ant-modal-title {
    font-size: 15px;
    font-weight: 700;
    color: #1d2433;
  }

  .ant-modal-body {
    padding: 8px 12px;
  }

  .ant-modal-close-x {
    width: 54px;
    height: 54px;
    line-height: 54px;
  }
`

export const ParticipationUserList = styled.div`
  max-height: 360px;
  overflow-y: auto;
  padding: 6px 4px;
`

export const ParticipationUserItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  transition: background-color 0.15s ease;

  &:hover {
    background: #f8f9fb;
  }

  & + & {
    margin-top: 2px;
  }
`

export const ParticipationUserInfo = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;

  .participation-user-name {
    font-size: 14px;
    color: #1d2433;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .participation-user-time {
    flex-shrink: 0;
    font-size: 12px;
    color: #98a2b3;
  }
`

export const ParticipationModalEmpty = styled.div`
  padding: 32px 0;
  text-align: center;
`
